/**
 * Tarot cards from generated data (scripts/importTarotFromXlsx.js).
 * Source: tarot_kortit_fi.xlsx or --fallback.
 */

import cardsGenerated from './tarot/cards.generated.json';

const SUIT_ORDER = ['wands', 'cups', 'swords', 'pentacles'];
const RANK_ORDER_MAJOR = Array.from({ length: 22 }, (_, i) => String(i));
const RANK_ORDER_MINOR = ['ace', '02', '03', '04', '05', '06', '07', '08', '09', '10', 'page', 'knight', 'queen', 'king'];

export const allCards = Array.isArray(cardsGenerated) ? cardsGenerated : [];

function isMajor(card) {
  return card.arcanaEn === 'Major Arcana' || (card.arcanaFi && card.arcanaFi.includes('Suuri'));
}

export function getMajorCards() {
  return allCards
    .filter(isMajor)
    .sort((a, b) => {
      const na = parseInt(a.rankEn, 10);
      const nb = parseInt(b.rankEn, 10);
      if (!Number.isNaN(na) && !Number.isNaN(nb)) return na - nb;
      return 0;
    });
}

export function getMinorCardsBySuit(suit) {
  const suitEn = suit === 'wands' ? 'Wands' : suit === 'cups' ? 'Cups' : suit === 'swords' ? 'Swords' : 'Pentacles';
  return allCards
    .filter(c => !isMajor(c) && (c.suitEn === suitEn || c.id.startsWith(suit + '-')))
    .sort((a, b) => {
      const ai = RANK_ORDER_MINOR.indexOf(a.id.replace(suit + '-', ''));
      const bi = RANK_ORDER_MINOR.indexOf(b.id.replace(suit + '-', ''));
      if (ai >= 0 && bi >= 0) return ai - bi;
      return String(a.rankEn).localeCompare(String(b.rankEn));
    });
}

export function getCardById(id) {
  return allCards.find(c => c.id === id) || null;
}

/**
 * TOC groups: Major Arcana, then Minor by suit (Sauvat/Wands, Maljat/Cups, Miekat/Swords, Lantit/Pentacles).
 */
export function getTocGroups() {
  const major = getMajorCards();
  const groups = [
    { id: 'major', titleFi: 'Suuri arkaana', titleEn: 'Major Arcana', cards: major }
  ];
  const suitKeys = ['wands', 'cups', 'swords', 'pentacles'];
  const suitTitlesFi = ['Sauvat', 'Maljat', 'Miekat', 'Lantit'];
  const suitTitlesEn = ['Wands', 'Cups', 'Swords', 'Pentacles'];
  suitKeys.forEach((suit, i) => {
    const cards = getMinorCardsBySuit(suit);
    if (cards.length) {
      groups.push({
        id: suit,
        titleFi: suitTitlesFi[i],
        titleEn: suitTitlesEn[i],
        cards
      });
    }
  });
  return groups;
}
